import Selector from "./Selector";

export type { SelectorOption } from "./Selector";
export default Selector;
